<template>
    <span class="wrap-image">
        <img
            :class="imgClass"
            v-if="image"
            v-on:click="$emit('clicked', propImage)"
            :src="src || image[size]"
            :data-fancybox="fancy"
            :data-caption="title"
            :data-large="src || image['large']"
            :data-medium="src || image['medium']"
            :data-small="src || image['small']"
            :alt="title" />
        <img v-if="!image" v-on:click="$emit('clicked', propImage)" :src="defaultImage">
    </span>
</template>

<script>
export default {
    name: 'wrap-image',
    props: ['propImage', 'propSize', 'alt', 'fancy', 'propClass'],
    data() {
      return {
          defaultImage: '/images/lazy.png'
      }
    },
    computed: {
        image() {
            let image = null

            if(this.propImage && Object.keys(this.propImage).length) {
                if(this.propImage.urls) {
                    image = this.propImage.urls
                } else {
                    image = this.propImage
                }
            }

            return image
        },
        size() {
            return this.propSize || 'medium'
        },
        hasFancy() {
            return typeof this.fancy !== "undefined"
        },
        title() {
            return this.src ? (this.alt || '') : (this.propImage && this.propImage.name ? this.propImage.name : '')
        },
        src() {
            return typeof this.propImage === 'string' && this.propImage
        },
        imgClass() {
            return this.propClass || ''
        }
    }
}
</script>
